module.exports = __webpack_public_path__ + "static/img/pay-affirm11.707c95bf.png";